import type { RouteRecordRaw } from 'vue-router';

export const infoFeatureItemRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/feature/item',
    name: 'infoFeatureItem',
    redirect: '/info/feature/item/list',
    component: () => import('pages/info/featureItem/FeatureItem.vue'),
    meta: {
      title: 'Feature Items',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoFeatureItemList',
        component: () => import('pages/info/featureItem/FeatureItemList.vue'),
        meta: {
          title: 'FeatureItems List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoFeatureItemDetail',
        component: () => import('pages/info/featureItem/FeatureItemDetail.vue'),
        meta: {
          title: 'FeatureItem Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoFeatureItemNew',
        component: () => import('pages/info/featureItem/FeatureItemNew.vue'),
        meta: {
          title: 'New FeatureItem',
          requiresAuth: true,
        },
      },
    ],
  },
];
